import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("owner_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-[hsl(var(--cream))]">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-border rounded-lg p-8 space-y-5" data-testid="admin-login-form">
        <div><p className="eyebrow">Owner dashboard</p><h1 className="text-3xl mt-2">Sign in</h1></div>
        <div className="space-y-1.5"><Label htmlFor="a-email">Email</Label><Input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></div>
        <div className="space-y-1.5"><Label htmlFor="a-pw">Password</Label><Input id="a-pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></div>
        {error && <p className="text-sm text-destructive" role="alert" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="w-full bg-primary text-primary-foreground py-3 rounded-full font-semibold disabled:opacity-60" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        <Link to="/admin/reset-password" className="block text-center text-sm underline" data-testid="forgot-password-link">Forgot password?</Link>
      </form>
    </div>
  );
}
